@if(image) {
  <div class="tile-container" [ngClass]="rootClassName">
  @switch (tileType) {
    @case ('rounded') {
      <div class="tile-rounded-container" [ngClass]="rootClassName">
        <div class="tile-rounded-row" [ngClass]="tileClassName" [ngStyle]="style">
          <div class="tile-rounded-rectangle">
            <img [src]="(imageURL|async)??''" width:auto height:auto [alt]="imageALT" class="tile-rounded-image"/>
          </div>
          <div class="tile-rounded-label">
            <span class="tile-rounded-text" [ngClass]="isWeb ? 'labelboldmedium' : 'labelmediumsmall'" tooltip="{{isWeb ? tooltip : ''}}">{{ title }}</span>
              @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="after" matBadgeOverlap="true"
              matBadgeColor="accent" matBadgeDescription="in dev"></span> }
          </div>
        </div>
      </div>
    }
    @case ('rounded-small') {
      <div class="tile-rounded-container" [ngClass]="rootClassName">
        <div class="tile-rounded-row" [ngClass]="tileClassName" [ngStyle]="style">
          <div class="tile-rounded-rectangle">
            <img [src]="(imageURL|async)??''" width:auto height:auto [alt]="imageALT" class="tile-rounded-image small"/>
          </div>
          <div class="tile-rounded-label">
            <span class="tile-rounded-text" [ngClass]="isWeb ? 'labelboldmedium' : 'labelmediumsmall'" tooltip="{{isWeb ? tooltip : ''}}">{{ title }}</span>
            @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="after" matBadgeOverlap="true" matBadgeColor="accent" matBadgeDescription="in dev"></span> }
          </div>
        </div>
      </div>
    }
    @case ('rectangle') {
      <div class="tile-rectangle-container" [ngClass]="rootClassName">
        <div class="tile-rectangle-row" [ngClass]="tileClassName" [ngStyle]="style">
          <div class="tile-rectangle-rectangle">
            <img [src]="(imageURL|async)??''" width:auto height:auto loading="eager" [alt]="imageALT" class="tile-rectangle-image"/>
          </div>
          <div class="tile-rectangle-label">
            <span class="tile-rectangle-label-text labelboldmedium" tooltip="{{isWeb ? tooltip : ''}}">{{ title }}</span>
            @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="after" matBadgeOverlap="true" matBadgeColor="accent" matBadgeDescription="in dev"></span> }
          </div>
        </div>
      </div>
    }
    @case ('badge') {
      <div class="tile-badge-container"  [ngClass]="rootClassName" [ngStyle]="style">
        <div class="tile-badge-image-row">
          <img [src]="(imageURL|async)??''" width:auto height:auto [alt]="imageALT" class="tile-badge-image"/>
          @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="above" matBadgeOverlap="true" matBadgeColor="accent" matBadgeDescription="in dev"></span> }
        </div>
        <div class="tile-badge-text-row">
          <span class="tile-badge-text linksmallmedium" tooltip="{{isWeb ? tooltip : ''}}">{{ title }}</span>
        </div>
      </div>
    }
    @default {
      <div class="tile-default-container bg-swatch-blue01 rounded-borders shadow grow" [ngClass]="rootClassName">
        <div class="tile-image-row">
          <img [src]="(imageURL|async)??''" width:auto height:auto [alt]="imageALT" class="tile-icon img-fluid" [ngClass]="{ finished: isFinishedForStudy }"/>
          @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="after" matBadgeOverlap="true" matBadgeColor="accent" matBadgeDescription="in dev"></span> }
        </div>
        <span class="title" tooltip="{{isWeb ? tooltip : ''}}">{{ title }}</span>
        <span class="subtitle" [ngClass]="visible && children.length > 0 ? 'visible' : 'invisible'">{{ countTitle }}</span>
      </div>
    }
  }
  </div>
}
